import { IDBPDatabase, openDB } from "idb";

export class IdbStorage {
  private dbName: string;
  private storeName: string;
  private dbPromise: Promise<IDBPDatabase>;

  constructor(dbName = "sqlQueriesDb", storeName = "sqlQueriesStore") {
    this.dbName = dbName;
    this.storeName = storeName;
    this.dbPromise = this._initDb();
  }

  private async _initDb(): Promise<IDBPDatabase> {
    return openDB(this.dbName, 1, {
      upgrade: (db: IDBPDatabase) => {
        if (!db.objectStoreNames.contains(this.storeName)) {
          db.createObjectStore(this.storeName);
        }
      },
    });
  }

  async setItem(key: string, value: any): Promise<void> {
    const db = await this.dbPromise;
    await db.put(this.storeName, value, key);
  }

  async getItem(key: string): Promise<any> {
    const db = await this.dbPromise;
    return await db.get(this.storeName, key);
  }

  async removeItem(key: string): Promise<void> {
    const db = await this.dbPromise;
    await db.delete(this.storeName, key);
  }
  async clearStore(): Promise<void> {
    const db = await this.dbPromise;
    const count = await db.count(this.storeName);

    if (count === 0) {
      throw new Error("Sem dados para serem removidos.");
    }

    await db.clear(this.storeName);
  }
}
